import { getWindow } from '@jira/ssr__browser-globals/src/getWindow.tsx';

export const getBuildVariant = (): string | undefined => getWindow()?.BUILD_VARIANT;
